import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Calendar from '../components/Calendar';
import BookingForm from '../components/BookingForm';
import BookingSuccess from '../components/BookingSuccess';
import './BookingPage.css';

function BookingPage() {
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [bookingSuccess, setBookingSuccess] = useState(false);
  const [appointmentId, setAppointmentId] = useState(null);

  const handleDateSelect = (date) => {
    console.log('Selected date:', date);
    setSelectedDate(date);
    setSelectedSlot(null);
  };

  const handleSlotSelect = (slot) => {
    console.log('Selected slot:', slot);
    setSelectedSlot(slot);
  };

  const handleBookingSuccess = (id) => {
    setAppointmentId(id);
    setBookingSuccess(true);
    // Reset selections
    setSelectedDate(null);
    setSelectedSlot(null);
  };

  const handleNewBooking = () => {
    setBookingSuccess(false);
    setAppointmentId(null);
    setSelectedDate(null);
    setSelectedSlot(null);
  };

  const refreshPage = () => {
    window.location.reload();
  };

  if (bookingSuccess) {
    return (
      <div className="booking-page">
        <div className="header">
          <h1>在线预约系统</h1>
          <div className="nav-buttons">
            <Link to="/manage" className="nav-button">管理预约</Link>
            <Link to="/admin-login" className="nav-button admin-button">管理员入口</Link>
          </div>
        </div>
        <BookingSuccess 
          appointmentId={appointmentId} 
          onNewBooking={handleNewBooking}
        />
      </div>
    );
  }

  return (
    <div className="booking-page">
      <div className="header">
        <h1>在线预约系统</h1>
        <div className="nav-buttons">
          <button onClick={refreshPage} className="nav-button refresh-button">刷新页面</button>
          <Link to="/manage" className="nav-button">管理预约</Link>
          <Link to="/admin-login" className="nav-button admin-button">管理员入口</Link>
        </div>
      </div>
      <div className="booking-container">
        <div className="calendar-section">
          <Calendar 
            selectedDate={selectedDate}
            onDateSelect={handleDateSelect}
            onSlotSelect={handleSlotSelect}
          />
        </div>
        
        {selectedSlot && (
          <div className="form-section">
            <BookingForm
              selectedDate={selectedDate}
              selectedSlot={selectedSlot}
              onBookingSuccess={handleBookingSuccess}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default BookingPage; 